import itemIds from './itemIds';

export const upsells = [
	{
		itemIds: [...itemIds.NT156],
		suggestedVideoEndcap: {
			header: 'You may also like:',
			suggestions: [
				{
					title: 'Mobile Ed Monthly Subscription',
					image: 'https://files.logoscdn.com/v1/files/3302355/content.png?signature=8GzS1mTq9zTCv1I5cBVxbmP3P_8',
					alt: 'World-class theological education for $49.99 per month. Over 30 hours of content each month.',
					target: '_top',
					productId: '56677',
				},
				{
					title: 'Mobile Ed Summer Session',
					url:
						'https://www.logos.com/summersession?utm_source=faithlifetv.com&utm_medium=website&utm_campaign=faithlifetv',
					image: 'https://files.logoscdn.com/v1/files/2499038/content.png?signature=1FlZa8UBSkEtlVDIQzrN_zkdpdA',
					target: '_top',
				},
			],
		},
	},
	{
		itemIds: [...itemIds.NT211],
		suggestedVideoEndcap: {
			header: 'You may also like:',
			suggestions: [
				{
					title: 'Mobile Ed Monthly Subscription',
					image: 'https://files.logoscdn.com/v1/files/3302355/content.png?signature=8GzS1mTq9zTCv1I5cBVxbmP3P_8',
					alt: 'World-class theological education for $49.99 per month. Over 30 hours of content each month.',
					target: '_top',
					productId: '56677',
				},
				{
					title: 'Explore Mobile Ed Courses',
					url:
						'https://www.logos.com/products/search?q=mobile+ed&Product+Type=Logos+Mobile+Education&utm_source=faithlifetv.com&utm_medium=website&utm_campaign=faithlifetv',
					image: 'https://files.logoscdn.com/v1/files/3490926/content.png?signature=08kLyDlSD06vLI8S9ps61AJeMds',
					target: '_top',
				},
			],
		},
	},
	{
		itemIds: itemIds.LogosMedia,
		suggestedVideoEndcap: {
			header: 'You may also like…',
			suggestions: [
				{
					title: 'Mobile Ed Monthly Subscription',
					image: 'https://files.logoscdn.com/v1/files/3302355/content.png?signature=8GzS1mTq9zTCv1I5cBVxbmP3P_8',
					alt: 'World-class theological education for $49.99 per month. Over 30 hours of content each month.',
					target: '_top',
					productId: '56677',
				},
				{
					title: 'Understanding the Context of the New Testament',
					url: '/media/306386',
					image: '//covers.logoscdn.com/vod/faithlife-today/testfaithlife-today-2314.jpg',
					target: '_top',
				},
			],
		},
	},
	{
		itemIds: [
			'489856', // Sneezing Jesus trailer
		],
		suggestedVideoEndcap: false,
	},
	{
		itemIds: [
			'499780', // The John Ankerberg Show trailer
		],
		suggestedVideoEndcap: false,
	},
	{
		itemIds: [
			'500780', // Fragments of Truth - Trailer
		],
		suggestedVideoEndcap: false,
	},
	{
		itemIds: [
			'500846', // Development Internship - Individual Story 3
			'500847', // Development Internship - Individual Story 2
			'500848', // Development Internship - Individual Story 1
		],
		suggestedVideoEndcap: false,
	},
];

export const defaultUpsell = {
	suggestedVideoEndcap: {
		header: 'You may also like…',
		suggestions: [],
	},
};
